import Button from "../core/Button";
import Strings from "../core/data/Strings";
import { GameObject } from "../core/GameObject";
import ScaleManager from "../core/ScaleManager";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import { GameScene } from "../scenes/GameScene";
import Fonts from "../utils/Fonts";
import Overlay from "../utils/Overlay";
import ConfirmQuitPopup from "./ConfirmQuitPopup";
import { HowToPlayScreen } from "./HowToPlayScreen";

export class PauseScreen extends GameObject {
    scene: GameScene;
    static ON_CLOSED = "onClosed";
    resize: () => void;
    helpButton: Button;
    quitButton: Button;
    popup: GameObject;
	constructor(scene: GameScene) {
		super(scene);
        this.scene = scene;

        const overlay = this.addImage("missionsBG");
		ScaleManager.ScaleBackgroundFromZone(overlay, scene.viewport);
        overlay.setInteractive();

        const starBurstSpine = scene.add.spine(0, 0, "star-burst", "starburst-idle", true);
        const starBurst = scene.add.spineContainer(0, 0, starBurstSpine);
        this.add(starBurst);
        const leftGlow = this.addImage("shopBGGlow");
        const rightGlow = this.addImage("shopBGGlow");
        
        const popup = this.popup = new GameObject(scene);
        this.add(popup);
        const bgGroup = scene.add.container();
        popup.add(bgGroup);
        const bg = popup.addImage("pauseBacker");
        const btnBacker = popup.addImage("pauseBtnBacker");
        bgGroup.add([bg, btnBacker]);
        const logo = popup.addImage("splashLogo");
        logo.scale = 0.575;

		const style = {
			fontFamily: Fonts.LuckiestGuy,
			color: "#ffeddf",
			fontSize: "58px",
            align: "center"
		};
        const soundOn = !this.scene.soundManager.muted;
		const soundButtonKey = soundOn ? "pauseSoundBtn" : "pauseSoundBtnOff";
        const resumeContainer = scene.add.container();
        const resumeBtn = scene.add.button(0, 0, "pausePlayBtn", undefined, this.exit, this, true);
        resumeContainer.setSize(resumeBtn.width, resumeBtn.height);
        const helpBtn = this.helpButton = scene.add.button(0, 0, "pauseHelpBtn", undefined, this.showHowToPlay, this, true);
		const soundBtn = scene.add.button(0,0, soundButtonKey, undefined, () => this.toggleSound(soundBtn), this, true)
        const homeBtn = this.quitButton = scene.add.button(0, 0, "pauseHomeBtn", undefined, this.returnHome, this, true);
        popup.add([resumeContainer, helpBtn, soundBtn, homeBtn]);

        const resumeText = scene.add.text(0, 0, Strings.get("Resume"), style);
        resumeContainer.add([resumeBtn, resumeText]);

        this.resize = () => {
            overlay.setSize(scene.viewport.width, scene.viewport.height);
            overlay.setDisplaySize(scene.viewport.width, scene.viewport.height);
            scene.alignIn.Center(overlay, scene.viewport);
            scene.alignIn.Center(popup, scene.viewport, 0, 0);
            scene.alignIn.Center(starBurst, scene.viewport, 0, 0);
            scene.alignIn.Center(leftGlow, scene.viewport, -300, 0);
            scene.alignIn.Center(rightGlow, scene.viewport, 300, 0);
    
            scene.alignIn.TopCenter(logo, bg, 0, 280);
            scene.alignIn.Center(resumeContainer, bg, 0, 300);
            scene.alignTo.BottomCenter(resumeText, resumeBtn, 0, 0);
            scene.alignIn.Center(btnBacker, bg, 0, 0);
            scene.alignIn.Center(helpBtn, btnBacker, 0, 0);
            scene.alignIn.Center(soundBtn, btnBacker, 280, 0);
            scene.alignIn.Center(homeBtn, btnBacker, -280, 0);
        }

        scene.addResize(this.resize);
		scene.resize();

        // Tween in --------
        logo.y -= 500;

        bgGroup.setScale(0);
        helpBtn.setScale(0);
        soundBtn.setScale(0);
        homeBtn.setScale(0);
        starBurst.setScale(0);
        resumeContainer.setScale(0);

        leftGlow.setAlpha(0);
        rightGlow.setAlpha(0);

        scene.tweens.add({
            targets: bgGroup,
            scale: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 200,
        });

        scene.tweens.add({
            targets: [helpBtn, soundBtn, homeBtn, resumeContainer],
            scale: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 300,
            delay: 100,
            onStart: () => {
                scene.tweens.add({
                    targets: logo,
                    y: logo.y + 500,
                    duration: 200,
                    ease: Phaser.Math.Easing.Back.Out,
                });

                scene.tweens.add({
                    targets: [starBurst, leftGlow, rightGlow],
                    scale: 1,
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    duration: 200,
                });

                scene.tweens.add({
                    targets: [leftGlow, rightGlow],
                    alpha: 1,
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    duration: 200,
                });
            }
        });
	}

	destroy(): void {
		this.scene.removeResize(this.resize);
		super.destroy();
	}

    toggleSound(btn: Button): void{
        this.scene.soundManager.muted = !this.scene.soundManager.muted;
		this.scene.sound.mute = this.scene.soundManager.muted;
		this.scene.music.muted = !this.scene.music.muted;
		if (!this.scene.soundManager.muted) btn.setTexture("pauseSoundBtn");
		else btn.setTexture("pauseSoundBtnOff");
    }
    
    showHowToPlay(): void{
        if(HowToPlayScreen.isOpen) return;
        this.helpButton.disableInteractive();
        const pop = new HowToPlayScreen(this.scene, () => this.helpButton.setInteractive());
        this.add(pop);
    }

    returnHome(): void{
        this.quitButton.disableInteractive();
        const pop = new ConfirmQuitPopup(this.scene, this, () =>{
            this.scene.gotoSplash();
        }, () => this.quitButton.setInteractive());
        this.add(pop);

        this.scene.tweens.add({
            targets: this.popup,
            y: this.popup.y + this.scene.viewport.height,
            duration: 400,
            ease: Phaser.Math.Easing.Back.In,
        });
    }

    exit(): void{
        this.emit(PauseScreen.ON_CLOSED);
        this.destroy();
    }

}